var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ModelCommunity {
    cdate;
    colors;
    comment;
    coverLink;
    downloadPublicCollections;
    edate;
    emailLogoLink;
    qaTrackingId;
    iconsColor;
    id;
    invoice;
    isAdvanced;
    isModerator;
    logoLink;
    logoUrl;
    maxUsers;
    mdate;
    name;
    notificationCode;
    pStatus;
    po;
    publicAllContent;
    publicUrl;
    role;
    sdate;
    status;
    storage;
    timezones;
    userId;
    watermark;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "cdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "colors", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "comment", void 0);
__decorate([
    Expose({ name: 'cover_link' }),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "coverLink", void 0);
__decorate([
    Expose({ name: 'download_public_collections' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "downloadPublicCollections", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "edate", void 0);
__decorate([
    Expose({ name: 'email_logo_link' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "emailLogoLink", void 0);
__decorate([
    Expose({ name: 'ga_tracking_id' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "qaTrackingId", void 0);
__decorate([
    Expose({ name: 'icons_color' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "iconsColor", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "invoice", void 0);
__decorate([
    Expose({ name: 'is_advanced' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "isAdvanced", void 0);
__decorate([
    Expose({ name: 'is_moderator' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "isModerator", void 0);
__decorate([
    Expose({ name: 'logo_link' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "logoLink", void 0);
__decorate([
    Expose({ name: 'logo_url' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "logoUrl", void 0);
__decorate([
    Expose({ name: 'max_users' }),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "maxUsers", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "name", void 0);
__decorate([
    Expose({ name: 'notification_code' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "notificationCode", void 0);
__decorate([
    Expose({ name: 'p_status' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "pStatus", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "po", void 0);
__decorate([
    Expose({ name: 'public_all_content' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "publicAllContent", void 0);
__decorate([
    Expose({ name: 'public_url' }),
    __metadata("design:type", Object)
], ModelCommunity.prototype, "publicUrl", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "role", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "sdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "storage", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", String)
], ModelCommunity.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunity.prototype, "watermark", void 0);
